import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const WarningFilledIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12.5C11 13.0523 11.4477 13.5 12 13.5C12.5523 13.5 13 13.0523 13 12.5V8ZM13 15.9688C13 15.4165 12.5523 14.9688 12 14.9688C11.4477 14.9688 11 15.4165 11 15.9688V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.9688Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

WarningFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default WarningFilledIcon;
